import Loading from 'components/dumb/loading/Loading'
import { useQuery } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { verifyEmailParams } from 'services/api/signup'

const VerifyToken = () => {
  const navigate = useNavigate()
  const { search: params } = useLocation()

  const { data } = useQuery(
    'verifyToken',
    async () => {
      const { data } = await verifyEmailParams(params)
      return data
    },
    {
      onSuccess: async (res) => {
        navigate('/signup/form', {
          state: {
            dataForm: res,
          },
        })
      },
      onError: async (err) => {
        navigate('/')
      },
    }
  )

  console.log(data)

  return <Loading show />
}

export default VerifyToken
